import React, { useState, useEffect, useRef } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { useDispatch, useSelector } from 'react-redux';
import { getWalletGrapth } from '../../../redux/wallet/action';
import ExportButtons from '../ExportButtons';
import { prepareChartData } from '../../../utils/graphUtils';

const BasicChartLineGraphHistory = ({ start_date, end_date, type, tab }) => {
  const dispatch = useDispatch();
  const chartRef = useRef(null);
  const { getwalletgraphdata } = useSelector(({ wallet }) => wallet);
  const [chartData, setChartData] = useState([]);

  // 🔹 Fetch wallet graph data
  useEffect(() => {
    if (start_date && end_date && type && tab) {
      dispatch(getWalletGrapth(start_date, end_date, type, tab));
    }
  }, [start_date, end_date, type, tab, dispatch]);

  // 🔹 Handle both yearly and date-based data
  useEffect(() => {
    const insights = getwalletgraphdata?.insights;
    if (Array.isArray(insights) && insights.length > 0) {
      const formattedData = insights.map(item => {
        const rawDate = item.date;
        const count = parseFloat(item.amount) || 0;

        // ✅ If date is just a year (like 2023)
        if (/^\d{4}$/.test(rawDate.toString())) {
          return { name: rawDate.toString(), count };
        }

        // ✅ Otherwise treat it as a real date
        const date = new Date(rawDate);
        if (!isNaN(date)) {
          const label = date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          });
          return { name: label, count };
        }

        return { name: rawDate, count };
      });

      setChartData(formattedData);
    } else {
      setChartData([]);
    }
  }, [getwalletgraphdata]);

  return (
    <>
      <ExportButtons targetRef={chartRef} filename="wallet_chart_history" data={chartData} />

      <div ref={chartRef}>
        <ResponsiveContainer width="100%" height={350}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              interval={0}
              textAnchor="end"
              height={60}
              tick={{ fontSize: 12 }}
            />
            <YAxis />
            <Tooltip
              formatter={(value, name) => [
                `${value.toLocaleString()}`,
                name === 'count' ? 'Amount' : name,
              ]}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#8884d8"
              strokeWidth={2}
              dot={{ r: 4 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default BasicChartLineGraphHistory;
